import React, { useEffect, useState } from 'react';
import BR24Logo from '../../../assets/br24-logo.svg';
import {
    StyledNavbar,
    NavbarWrapper,
    NavbarTitle,
    LogoWrapper,
    NavbarInner,
    CaptionWrapper,
    MainCaption,
    DotCaptionSpan,
    Dot,
    ReadProgress
} from './styles.Navbar';
import { Caption } from '../../../config/models';
import { mainConfig } from '../../../config/config.provider';
import { Sharing } from '../../custom/sharing/Sharing';
import { DeviceDetector } from '../../../utils/helper/browserDetection';
import { useGlobal } from '../../../logic/main';
import { STYLE } from '../../../styles/variables';
import { getNavbarHeight, getPageWidth } from '../../../utils/helper/helpers';
import { boardConfig } from '../../../config/boardConfig';

interface DotCaptionProps {
    caption: Caption;
}

let lastScroll = 0;

export const DotCaption: React.FC<DotCaptionProps> = ({ caption }) => (
    <DotCaptionSpan>
        <Dot caption={caption} />
        {caption}
    </DotCaptionSpan>
);

interface HeaderProps {
    showProgress?: boolean;
}

export const Navbar: React.FC<HeaderProps> = ({ showProgress }) => {
    let resizeTimer: ReturnType<typeof setTimeout>;

    const [navbarHeight, setNavbarHeight] = useGlobal(
        state => state.navbarHeight,
        actions => actions.setNavbarHeight
    );
    const [isExpanded, setIsExpanded] = useState(true);
    const [showTitle, setShowTitle] = useState(false);

    const handleScroll = () => {
        const pageDimensions = document.body.getBoundingClientRect();

        // detects new state and compares it with the new one
        if (pageDimensions.top > lastScroll) {
            setIsExpanded(true);
        } else if (pageDimensions.top < parseInt(navbarHeight)) {
            setIsExpanded(false);
        }

        if (pageDimensions.top < 0) {
            setShowTitle(true);
        } else {
            setShowTitle(false);
        }
        // saves the new position for iteration.
        lastScroll = pageDimensions.top;
    };

    const handleResize = () => {
        const newNavbarHeight = getNavbarHeight(STYLE.navbar.sizes, getPageWidth());

        if (newNavbarHeight !== navbarHeight) {
            setNavbarHeight(newNavbarHeight);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    window.addEventListener('resize', () => {
        clearInterval(resizeTimer);
        resizeTimer = setTimeout(handleResize, 100);
    });

    return (
        <StyledNavbar height={navbarHeight} isExpanded={isExpanded} caption={mainConfig.caption}>
            <LogoWrapper href="https://www.br.de/nachrichten/">
                <BR24Logo />
            </LogoWrapper>
            <NavbarWrapper>
                <NavbarInner>
                    {!!mainConfig.caption ? (
                        <MainCaption>
                            <DotCaption caption={mainConfig.caption} />
                        </MainCaption>
                    ) : null}
                    <NavbarTitle showTitle={showTitle}>{mainConfig.title}</NavbarTitle>
                    <Sharing style={{ marginLeft: 'auto' }} />
                </NavbarInner>
                <CaptionWrapper caption={mainConfig.caption} isExpanded={isExpanded}>
                    {boardConfig.debug
                        ? '3D-DEBUG-MODUS: Nutze die Maus um die Szene zu inspizieren'
                        : mainConfig.caption}
                </CaptionWrapper>
                {DeviceDetector.isSafari || !showProgress ? null : (
                    <ReadProgress height={navbarHeight} isExtended={isExpanded} caption={mainConfig.caption} />
                )}
            </NavbarWrapper>
        </StyledNavbar>
    );
};
